import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../../components/Icon';
import { theme } from '../../../../styles/theme';
import { optionHover } from '../../../../styles/shareableStyles';

interface IProps {
  name: string;
  onClick: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 5px 12px;
  color: ${theme.colors.secondary800};
  &:hover {
    ${optionHover};
    cursor: pointer;
  }
`;
const Name = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
`;

const DashboardFolderWidgetFolder = ({ name, onClick }: IProps) => {
  return (
    <Container onClick={onClick}>
      <SvgIcon name="folder" width={16} height={16} customFill="currentColor" />
      <Name>{name}</Name>
    </Container>
  );
};

export default DashboardFolderWidgetFolder;
